import { IRestModel, RestApi } from "@nkr/utils/rest-api";

export interface IDashParentReferralSource extends IRestModel {
    id: number,
    name: string,
}

export interface IDashReferralSource extends IRestModel {
    id: number,
    srcCode: string,
    description: string,
    parentReferralSourceId: number | null,
    parentReferralSourceName: string,
    isKeyReferrer: boolean,
    isNkrCampaign: boolean,
    overwriteToLegacyGenericPage: boolean,
    donorConnectGroup: number | null,
    donorConnectGroupName: string | null,
    activePageId: number,
    activePageName: string,
    pageCount: number,
}

export interface IDashDynamicRegPage extends IRestModel {
    id: number,
    entryReferrerId: number,
    name: string,
    referralSourceCode: string,
    referralSourceDisplayName: string,
    createdDate: string,
    isActive: boolean,
    heroRibbonImageUrlEn: string,
    heroRibbonImageUrlEs: string,
    heroTextOverlayEn: string,
    heroTextOverlayEs: string,
    heroTextOverlayAlignment: string,
    ribbonTwoMediaUrlEn: string,
    ribbonTwoMediaUrlEs: string,
    ribbonTwoTitleEn: string,
    ribbonTwoTitleEs: string,
    ribbonTwoIntroParagraphEn: string,
    ribbonTwoIntroParagraphEs: string,
    ribbonTwoBodyParagraphEn: string,
    ribbonTwoBodyParagraphEs: string,
}

export const DashParentReferralSourceApi = new RestApi<IDashParentReferralSource, IDashParentReferralSource>(`${__API__}/dash/parent-src`)
    .makeHooks();

export const DashReferralSourceApi = new RestApi<IDashReferralSource, IDashReferralSource>(`${__API__}/dash/referral-sources`)
    .makeHooks();

export const useDynamicRegPageApi = (referralSourceId?: number | string) => {
    const safeReferralSourceId = referralSourceId ?? "{referralSourceId}";

    return new RestApi<IDashDynamicRegPage, IDashDynamicRegPage>(`${__API__}/dash/referral-sources/${safeReferralSourceId}/pages`)
        .withCustomUpdatePath(`${__API__}/dash/referral-sources/pages/{id}`)
        .withCustomDeletePath(`${__API__}/dash/referral-sources/pages/{id}`)
        .makeHooks();
};